import styled from 'styled-components'

export const TableWrapper = styled.div`
display: flex;
`

export const StyledTable = styled.div`
text-align: left;
overflow-x: auto;

table {
  border-collapse: collapse;
  margin: 1rem;
  background: white;

  caption {
    margin: 1rem;
    font-size: 1.4em;
  }
}
thead > tr >th {
  font-size: 1.8em;
  font-weight: 400;
}

th,
td {
  border: 2px solid rgba(0, 0, 0, 0.5);
  border-collapse: collapse;
  padding: 0.75rem;
  font-size: 1.5em;
  font-weight: 300;
}
th {
  text-align: left;
  font-weight: bold;
}
td {
  text-align: right;
}

tbody tr:nth-child(odd) {
  background-color: rgba(255, 255, 255, 0.5);
}
`
